
export class Utils {
    static isArray(value: string | string[]) {
        return value instanceof Array;
    }
}
